module.exports = __webpack_public_path__ + "static/img/ProximaNova-Semibold.f3fb4078.svg";